module.exports = __webpack_public_path__ + "static/img/vr.14c0597.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/vr.jpg
// module id = fXaH
// module chunks = 1